import { Grid } from '@mui/material';
import * as React from 'react';
import * as Redux from 'react-redux';
import { ModalComponent } from '../../../widgets';
import BotonComponent from '../../dashboard/components/BotonNuevo';
import { allAularioAction, setActivoAularioAction } from './AularioAction';
import { PARAMS_AULARIO } from './AularioReducer';
import FormAulario from './components/FormAulario';
import ListadoAulario from './components/ListadoAulario';

const AularioView = () => {
  const dispatch = Redux.useDispatch();

  const entidadesStore = Redux.useSelector((state) => state.entidades);
  const aularioStore = Redux.useSelector((state) => state.aulario);

  const [openModalForm, setOpenModalForm] = React.useState(false);

  return (
    <Grid container spacing={1}>
      <Grid item md={12}>
        <BotonComponent
          click={async () => {
            await setActivoAularioAction(dispatch, null);
            setOpenModalForm(true);
          }}
          green
          addIcon
          mr={2}
        />
        <BotonComponent
          click={async () => {
            await setActivoAularioAction(dispatch, null);
            const payload = {
              ...aularioStore.params,
              idEntidad: entidadesStore.activo.id,
            };
            dispatch({
              type: PARAMS_AULARIO,
              payload,
            });
            await allAularioAction(dispatch, payload);
          }}
          disabled={aularioStore.all.length === 0 || aularioStore.loadingAll}
          white
          refreshIcon
          text={aularioStore.loadingAll ? 'Actualizando...' : 'Actualizar'}
        />
      </Grid>
      <Grid item md={12}>
        <ListadoAulario setOpenModalForm={(val) => setOpenModalForm(val)} />
      </Grid>
      <ModalComponent
        id="modalFormAulario"
        title={`${
          aularioStore.activo
            ? `Editar ${aularioStore.activo.nombre}`
            : 'Nueva aula'
        }`}
        maxWidth="sm"
        open={openModalForm}
        onClose={() => setOpenModalForm(!openModalForm)}
      >
        <FormAulario
          activo={aularioStore.activo}
          setOpenModalForm={(val) => setOpenModalForm(val)}
        />
      </ModalComponent>
    </Grid>
  );
};

export default AularioView;
